var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSeeList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7449 12.0207C16.1785 11.173 14.9089 9.75 12.7702 9.75C10.6318 9.75 9.36179 11.1726 8.79545 12.0207C8.49527 12.4705 8.49527 13.0291 8.79545 13.4793C9.36222 14.327 10.6318 15.75 12.7702 15.75C14.9089 15.75 16.1785 14.3274 16.7449 13.4793C17.0455 13.0295 17.0455 12.4709 16.7449 12.0207ZM16.191 13.1808C15.6949 13.9237 14.5906 15.1697 12.7702 15.1697C10.9497 15.1697 9.84544 13.9237 9.3493 13.1808C9.17229 12.9153 9.17229 12.5851 9.3493 12.3199C9.84544 11.5771 10.9501 10.331 12.7702 10.331C14.591 10.331 15.6953 11.5771 16.191 12.3199C16.3684 12.5851 16.3684 12.9153 16.191 13.1808ZM12.7702 11.1052C11.7611 11.1052 10.9398 11.8434 10.9398 12.7504C10.9398 13.6573 11.7611 14.3955 12.7702 14.3955C13.7792 14.3955 14.6005 13.6573 14.6005 12.7504C14.6005 11.8434 13.7792 11.1052 12.7702 11.1052ZM12.7702 13.8149C12.1168 13.8149 11.5858 13.3376 11.5858 12.7504C11.5858 12.1632 12.1168 11.6859 12.7702 11.6859C13.4235 11.6859 13.9545 12.1632 13.9545 12.7504C13.9545 13.3376 13.4235 13.8149 12.7702 13.8149Z",
    fill: "#344054",
    stroke: "#344054",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66753 1H5.17865C3.87186 1 3.21846 1 2.71933 1.25432C2.28029 1.47802 1.92334 1.83498 1.69963 2.27402C1.44531 2.77315 1.44531 3.42654 1.44531 4.73333V11.2667C1.44531 12.5735 1.44531 13.2269 1.69963 13.726C1.92334 14.165 2.28029 14.522 2.71933 14.7457C3.21846 15 3.87186 15 5.17865 15H6.88976M7.66753 1L12.3342 5.66667M7.66753 1V3.17778C7.66753 4.04897 7.66753 4.48457 7.83708 4.81732C7.98622 5.11002 8.22419 5.34798 8.51688 5.49712C8.84963 5.66667 9.28523 5.66667 10.1564 5.66667H12.3342M12.3342 5.66667V7.22222M4.55642 11.8889H6.11198M4.55642 8.77778H7.66753M4.55642 5.66667H5.3342",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSeeList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iconSeeList.93f8bb7f5363328c0124edd651148865.svg";